//y chang Popover chi bo sung getTooltipContainer={(triggerNode) => triggerNode.parentNode} //tranh bi scroll len dau khi mo popover
import RcTooltip from "rc-tooltip"
import React from "react"
import "rc-tooltip/assets/bootstrap.css"
import "./m-popover.css"
import { isOnScreen } from "src/core/helpers/utils"
function RcPopover(props) {
  const [visible, setVisible] = React.useState(false)
  const [fnCallBack, setFnCallBack] = React.useState<any>({})
  const { disabled } = props
  if (props.refShowPopover) {
    props.refShowPopover.current = setVisible
  }
  React.useEffect(() => {
    // console.log(`visible đã thay đổi: ${visible}`)
    if (visible === false) {
      if (fnCallBack && fnCallBack.fnOnHide) {
        if (props.delayHide > 0) {
          setTimeout(() => {
            fnCallBack.fnOnHide()
          }, props.delayHide)
        } else {
          fnCallBack.fnOnHide()
        }
      }
    } else {
      setFnCallBack({}) //khi show lại thì reset fnCallBack
    }
  }, [visible])
  if (disabled) {
    return props.children
  }

  if (props.overlay)
    return (
      <RcTooltip
        trigger={"click"}
        placement="top"
        // prefixCls="m-popover"
        visible={visible}
        onVisibleChange={v => {
          if (props.debug) {
            console.log("onVisibleChange", visible)
          }
          setVisible(v)
        }}
        overlayClassName="m-popover"
        onPopupAlign={(node, align) => {
          if (props.autoScrollIntoViewWhenOutOfScreen) {
            if (!isOnScreen(node)) {
              console.warn("onPopupAlign:", node, align, node.offsetTop)
              node.scrollIntoView({ behavior: "smooth" })
            }
          }
        }}
        getTooltipContainer={triggerNode => triggerNode.parentNode}
        {...props}
        overlay={() => {
          // console.warn("typeof ", typeof props.overlay)
          if (typeof props.overlay == "function") {
            return props.overlay({
              hide: () => {
                setVisible(false)
              },
              hidePopover: () => {
                setVisible(false)
              },
              //bo sung hidePopoverWithCallback de tranh bi loi hide khi component cha da bien mat
              hidePopoverWithCallback: fnOnHide => {
                setFnCallBack({
                  fnOnHide,
                })
                setVisible(false)
              },
            })
          }
          return props.overlay
        }}
      >
        {props.children}
      </RcTooltip>
    )
  return props.children
}

export default RcPopover
